import React, { useState, useEffect } from "react";
import NavBar from "./Components/NavBar";
import ItemEvento from "./Components/ItemEvento";
import withReactContent from "sweetalert2-react-content";
import { useNavigate, useParams, Link } from "react-router-dom";
import { getDoc, setDoc, doc, query, where } from "firebase/firestore";
import ItemAsientosPaulet from "./Components/ItemAsientosPaulet";
import LlenarDatosPaulet from "./LlenarDatosPaulet";

import { db } from "./FirebaseConfig/firebase";
import { collection, getDocs } from "firebase/firestore";
import "./CSS/registrarParticipantePaulet.css";
import { addDoc } from "firebase/firestore";
import InfoEvento from "./Components/InfoEvento";
import Swal from "sweetalert2";

const MySwal = withReactContent(Swal);

function RegistrarParticipantePaulet(props) {
  const { idUsuario, cip, nombreUsuario } = props;
  const navigate = useNavigate();
  const { id } = useParams();
  const [estado, setEstado] = React.useState("");
  const [salon, setSalon] = React.useState("");
  const [nombre, setNombre] = React.useState("");
  const [fecha, setFecha] = React.useState("");
  const [maxAsientos, setMaxAsientos] = React.useState("");
  const [tipoEvento, setTipoEvento] = React.useState("");

  //Variables para identificar si ya existe entradas reservadas para actualizarlas o recien va a reservar
  const [isNew, setIsNew] = React.useState(true);
  const [idUpdate, setIdUpdate] = React.useState();
  const [idDocReserva, setIdDocReserva] = React.useState();
  const [isPago, setIsPago] = React.useState(false);
  const [tickets, setTickets] = React.useState();
  const [costo, setCosto] = React.useState(0);

  const [descripcion, setDescripcion] = React.useState("");
  const [urlImagen, setUrlImage] = useState("");
  const [listaAsientos, setListaAsientos] = useState([]);
  const [listaRegistro, setListaRegistro] = useState([]);
  const [listaAsientosRegistrados, setListaAsientosRegistrados] = useState([]);
  const [datosCargados, setDatosCargados] = useState(false); // MOSTRAR BARRA DE CARGA
  const [listaAsientosExtras, setListaAsientosExtras] = React.useState(""); // lista de asientos que seran para pagar

  const [visMA, setvisMA] = React.useState(false); // Mostrar cuantos asientos son maximo
  const [visAC, setvisAC] = React.useState(false); // Mostrar asiento colegiado
  const [visAI, setvisAI] = React.useState(false); // Mostrar asiento Invitado
  const [visAE, setvisAE] = React.useState(false); // Mostrar asiento extras
  const [visAS, setvisAS] = React.useState(false); // Mostrar asiento en total
  const [cerrarVisible, setCerrarVisible] = React.useState(false); // Mostrar asiento en total
  const [hora, setHora] = React.useState("");
  const [showMore, setShowMore] = useState(false);

  const [derVisible, setDerVisible] = useState(false); // MOSTRAR Boton de continuar

  //Funcion para mostrar detalles del evento
  const getEventoById = async (id) => {
    const evento = await getDoc(doc(db, "EVENTOS", id));
    if (evento) {
      setNombre(evento.data().nombre);
      setDescripcion(evento.data().descripcion);
      setUrlImage(evento.data().urlImagen);
      setEstado(evento.data().estado);
      setSalon(evento.data().salon);
      setFecha(evento.data().fecha);
      setHora(evento.data().fecha.split(" ")[1]);

      setMaxAsientos(evento.data().maxAsientos);
      setTipoEvento(evento.data().tipoEvento);
    } else {
      console.log("no existe");
    }
    setDatosCargados(true);
  };

  //Funcion para llenar asientos reservados
  const buscarAsientosReservados = async () => {
    const cuponesList = collection(db, `EVENTOS/${id}/AsientosRegistrados`);
    const data = await getDocs(cuponesList);
    const tickets = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
    setListaRegistro(tickets);
  };

  //Funcion para marcar asientos reservados
  const marcarAsientosReservados = async () => {
    const q = query(
      collection(
        db,
        `USUARIOS/${localStorage.getItem("idDocumento")}/AsientosRegistrados`
      ),
      where("idEvento", "==", id)
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      setListaAsientos(doc.data().asientos.split(","));
      setIdDocReserva(doc.data().idEntrada);
      setIdUpdate(doc.id);
    });
  };

  //Funcion para marcar asientos reservados
  const marcarAsientos = () => {
    const ticketsCollectionRef = db.collection(
      `EVENTOS/${id}/AsientosRegistrados`
    );
    ticketsCollectionRef.get().then((snapshot) => {
      const ticketsList = [];
      snapshot.forEach((doc) => {
        const ticket = { id: doc.id, ...doc.data() };
        ticketsList.push(ticket);
      });
      setTickets(ticketsList);
      console.log(ticketsList);
    });
  };
  //cerrar eventos
  const cerrar = () => {
    if (localStorage.getItem("nivelUsuario") == "ingeniero") {
      navigate("../panelUser/eventos");
    } else {
      if (localStorage.getItem("nombreLocal") == "CIP") {
        navigate("../panelCDA/eventos");
      } else navigate("../panelAdmin/eventos");
    }
  };
  const toggleShowMore = () => {
    setShowMore(!showMore);
  };
  useEffect(() => {
    getEventoById(id);
    if (fecha == "") {
      getEventoById(id);
    }
    //console.log(id);
  }, [fecha]);

  useEffect(() => {
    buscarAsientosReservados();
    if (localStorage.getItem("nivelUsuario") == "ingeniero") {
      setDerVisible(false);
      marcarAsientosReservados();
    }
    if (localStorage.getItem("nombreLocal") == "CIP") {
      setDerVisible(false);
      marcarAsientosReservados();
    }
  }, []);
  useEffect(() => {
    var listilla = [];

    listaRegistro.map(({ asientos }) => {
      //console.log("asientos " + asientos + " lista asientos " + listaAsientos);
      //console.log(asientos==listaAsientos);

      if (localStorage.getItem("nombreLocal") == "CIP") {
        if (asientos != listaAsientos) {
          const answer_array = asientos.split(",");
          listilla = listilla.concat(answer_array);
          setListaAsientosRegistrados(listilla);
        } else {
          setIsNew(false);
        }
      } else {
        if (asientos == listaAsientos) {
          setIsNew(false);
        }
        const answer_array = asientos.split(",");
        listilla = listilla.concat(answer_array);
        setListaAsientosRegistrados(listilla);
      }
      //Codigo para modificar asientos que ya estan registrados
      /**/
      /*
      if (asientos == listaAsientos) {
        setIsNew(false);
      }
      const answer_array = asientos.split(",");
      listilla = listilla.concat(answer_array);
*/
      //console.log(listilla);
    });
  }, [listaRegistro]);

  useEffect(() => {
    Swal.fire({
      title: "Instrucciones",
      html: "1. Seleccione primero los asientos que quiere reservar <br> 2. Click en el boton continuar  <br>3.Verificar datos y click en el boton Reservar",

      icon: "info",
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Continuar",
    }).then((result) => {});
    if (localStorage.getItem("idLocal") == "") {
      const idLocal = localStorage.getItem("idLocal");
      //console.log("NO ES USER");
      navigate("../login");
    } else {
      setNombre(localStorage.getItem("nombreLocal"));
    }
  }, []);
  useEffect(() => {
    if (localStorage.getItem("nombreLocal") == "CIP") {
      setMaxAsientos("400");
    }
  }, [maxAsientos]);

  useEffect(() => {
    if (tipoEvento == "Colegiatura") {
      setvisAC(true);
    } else {
      setvisMA(true);
    }
    //console.log("NO ES USER");
  }, [tipoEvento]);

  useEffect(() => {
    if (tipoEvento == "Colegiatura") {
      //console.log("TIPOEvento" + localStorage.getItem("apellidoLocal"));

      if (localStorage.getItem("apellidoLocal") != "CDA") {
        setvisAS(false);
        if (listaAsientos.length >= 1) {
          setvisAI(true);
        }
        if (listaAsientos.length >= 3) {
          setvisAE(true);
          setCosto((listaAsientos.length - 3) * 25);
        }
        if (listaAsientos.length >= 4) {
          setIsPago(true);
        }
        if (listaAsientos.length < 4) {
          setIsPago(false);
        }
      } else {
        setvisAI(false);
        setvisAE(false);
        setvisAC(false);
        setvisMA(true);
        setvisAS(true);
      }
    } else {
      setvisAI(false);
      setvisAE(false);
      setvisAC(false);
      setvisMA(true);
      setvisAS(true);
    }
  }, [listaAsientos]);

  if (!datosCargados) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "0px auto",
          textAlign: "center",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ verticalAlign: "middle", display: "block" }}>
          <div>
            <img
              style={{ height: "300px" }}
              src={require(`./img/docucargando.gif`)}
              alt="esperando"
            />
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="paulet-eventos">
      <NavBar
        titulo="Reservar Participantes | Auditorio Paulet"
        imagen="cerrar"
        logoTitulo="eventos"
        cerrar={cerrar}
        cerrarVisible={cerrarVisible}
      ></NavBar>
      <div className="paulet-registrar-grid-container">
        <div className="paulet-padre-izquierda">
          <div className="paulet-hijo-izquierda">
            <div className="paulet-infoEvento">
              <InfoEvento
                nombre={nombre}
                fecha={fecha}
                descripcion={descripcion}
                id={id}
                hora={hora}
                imagen={urlImagen}
              />
            </div>
            {visMA ? (
              <p style={{ fontSize: "20px" }}>
                Puede seleccionar maximo {maxAsientos} asientos{" "}
              </p>
            ) : null}
            {visAC ? (
              <div>
                <p style={{ fontSize: "20px" }}>
                  &nbsp;&nbsp;Asiento de colegiado.
                </p>
                <p style={{ fontSize: "20px" }}>
                  &nbsp;&nbsp;{listaAsientos[0]}
                </p>
              </div>
            ) : null}
            {visAI ? (
              <div>
                <p style={{ fontSize: "20px" }}>
                  &nbsp;&nbsp;Asientos de los invitados (2).
                </p>
                <p style={{ fontSize: "20px" }}>
                  &nbsp;&nbsp;{listaAsientos.slice(1, 3).join(", ")}
                </p>
              </div>
            ) : null}
            {visAE ? (
              <div>
                <p style={{ fontSize: "20px" }}>
                  &nbsp;&nbsp;Asientos extras (S/{costo} )
                </p>
                <p style={{ fontSize: "20px" }}>
                  &nbsp;&nbsp;{listaAsientos.slice(3).join(", ")}
                </p>
              </div>
            ) : null}

            {visAS ? (
              <div style={{ width: "300px" }}>
                {listaAsientos.length > 0 ? (
                  <h1 style={{ fontSize: "20px" }}>Asientos seleccionados: </h1>
                ) : null}

                <p className="paulet-lista-asientos">
                  {showMore
                    ? listaAsientos.toString()
                    : listaAsientos.toString().slice(0, 30)}
                  {listaAsientos.toString().length > 30 ? (
                    <button onClick={toggleShowMore} className="text-button">
                      {showMore ? "Ver menos" : "Ver más ... "}
                    </button>
                  ) : null}
				  
                </p>
              </div>
            ) : null}

            <div className="paulet-contenido-inferior">
              <div className="paulet-btnInferior">
                <input
                  type="submit"
                  value={derVisible ? "Volver atras" : "Continuar"}
                  style={{
                    cursor:
                      listaAsientos.length > 0 ? "default" : "not-allowed",
                    opacity: listaAsientos.length > 0 ? "1" : "0.65",
                  }}
                  className="paulet-btnAbajoContinuar"
                  onClick={() =>
                    listaAsientos.length > 0
                      ? (setDerVisible(!derVisible),
                        setCerrarVisible(!cerrarVisible))
                      : (setCerrarVisible(false), null)
                  }
                />
              </div>

              <Link
                to={`/panelAdmin/eventos/${id}/reporte`}
                className="paulet-label"
                style={{ textAlign: "center", marginTop: "18px" }}
              >
                {!derVisible &&
                localStorage.getItem("nivelUsuario") != "ingeniero" ? (
                  <div className="paulet-btnInferior">
                    <input
                      type="submit"
                      value="Ver Reporte"
                      className="paulet-btnAbajoReporte"
                    />
                  </div>
                ) : null}
              </Link>
            </div>
          </div>
        </div>
        <div className="paulet-padre-derecha">
          <div className="paulet-hijo-derecha">
            {derVisible ? (
              <LlenarDatosPaulet
                listaAsientos={listaAsientos}
                id={id}
                nombre={nombre}
                isNew={isNew}
                idDocReserva={idDocReserva}
                idUpdate={idUpdate}
                setListaAsientos={setListaAsientos}
                maxAsientos={maxAsientos}
                setIsNew={setIsNew}
                isPago={isPago}
                setIdDocReserva={setIdDocReserva}
                setIdUpdate={setIdUpdate}
                cip={cip}
                costo={costo}
                lugar={"Auditorio Paulet"}
              ></LlenarDatosPaulet>
            ) : (
              <ItemAsientosPaulet
                listaAsientos={listaAsientos}
                setListaAsientos={setListaAsientos}
                listaAsientosRegistrados={listaAsientosRegistrados}
                maxAsientos={maxAsientos}
                tipoEvento={tipoEvento}
              ></ItemAsientosPaulet>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
export default RegistrarParticipantePaulet;
